import api from "./api";

export const createWarehouseShelf = async (payload) => {
    const response = await api.post(
        "/warehouseshelf",
        {
            warehouseZoneId: Number(
                payload.warehouseZoneId
            ),
            code: payload.code?.trim() || "",
            maxWeightKg: Number(
                payload.maxWeightKg
            ),
            maxVolumeM3: Number(
                payload.maxVolumeM3
            ),
            isBlocked: Boolean(
                payload.isBlocked
            ),
            notes:
                payload.notes?.trim() || null,
        }
    );

    return response.data;
};

export const getWarehouseShelves = async () => {
    const response = await api.get(
        "/warehouseshelf"
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const getWarehouseShelfById = async (id) => {
    const shelfId = Number(id);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehouseshelf/${shelfId}`
    );

    return response.data;
};

export const getWarehouseShelvesByZone = async (
    warehouseZoneId
) => {
    const zoneId = Number(warehouseZoneId);

    if (
        !Number.isInteger(zoneId) ||
        zoneId <= 0
    ) {
        throw new Error(
            "Warehouse zone ID must be a positive integer."
        );
    }

    const response = await api.get(
        `/warehouseshelf/zone/${zoneId}`
    );

    return Array.isArray(response.data)
        ? response.data
        : [];
};

export const updateWarehouseShelf = async (
    id,
    payload
) => {
    const shelfId = Number(id);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.put(
        `/warehouseshelf/${shelfId}`,
        {
            code: payload.code?.trim() || "",
            maxWeightKg: Number(
                payload.maxWeightKg
            ),
            maxVolumeM3: Number(
                payload.maxVolumeM3
            ),
            isBlocked: Boolean(
                payload.isBlocked
            ),
            notes:
                payload.notes?.trim() || null,
        }
    );

    return response.data;
};

export const setWarehouseShelfBlocked = async (
    id,
    isBlocked
) => {
    const shelfId = Number(id);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.patch(
        `/warehouseshelf/${shelfId}/blocked`,
        {
            isBlocked: Boolean(isBlocked),
        }
    );

    return response.data;
};

export const deleteWarehouseShelf = async (id) => {
    const shelfId = Number(id);

    if (
        !Number.isInteger(shelfId) ||
        shelfId <= 0
    ) {
        throw new Error(
            "Warehouse shelf ID must be a positive integer."
        );
    }

    const response = await api.delete(
        `/warehouseshelf/${shelfId}`
    );

    return response.data;
};

const warehouseShelfService = {
    createWarehouseShelf,
    getWarehouseShelves,
    getWarehouseShelfById,
    getWarehouseShelvesByZone,
    updateWarehouseShelf,
    setWarehouseShelfBlocked,
    deleteWarehouseShelf,
};

export default warehouseShelfService;